export default __webpack_public_path__ + "static/media/floral.inline.1f8ddeb6.svg";